export function findDepartment(
  dept: number,
  options: (DepartmentType & { value?: number })[]
): DepartmentType {
  return options.find((opt) => opt.value === dept)
}

export function createDepartmentOptions(
  options: DepartmentType[]
): FilterType[] {
  return options.map((department) => ({
    value: department.id,
    label: department.name,
    type: "department"
  }))
}

export function createUserOptions(options: UserType[]): FilterType[] {
  return options.map((user) => {
    return {
      value: user.id,
      label: user.name,
      type: "user"
    }
  })
}

export const statusFilterOptions: FilterType[] = [
  { type: "status", value: "on_track", label: "On Track" },
  { type: "status", value: "at_risk", label: "At Risk" },
  { type: "status", value: "critical", label: "Critical" },
  { type: "status", value: "complete", label: "Complete" },
  { type: "status", value: "past_due", label: "Past Due" },
  { type: "status", value: "on_hold", label: "On Hold" },
  { type: "status", value: "not_met", label: "Not Met" }
]

export function createAllOptions(
  departments: DepartmentType[],
  users: UserType[],
  page: string
): FilterType[] {
  if (page === "assignee") {
    return [
      ...statusFilterOptions,
      ...createDepartmentOptions(departments),
      ...createUserOptions(users)
    ]
  } else {
    return [...statusFilterOptions, ...createDepartmentOptions(departments)]
  }
}

export function getQuarter(
  year: number,
  quarter: number,
  prevNext: "prev" | "next"
): string {
  let yearN: number = year
  let quarterN: number = quarter

  if (prevNext === "next") {
    quarterN += 1
    if (quarterN > 4) {
      quarterN = 1
      yearN++
    }
  }
  if (prevNext === "prev") {
    quarterN -= 1
    if (quarterN < 1) {
      quarterN = 4
      yearN--
    }
  }

  return `q${quarterN}-${yearN}`
}

export function createExpectedOptions(
  dates: { quarter: number; year: number },
  rangeOptions: string[]
): FilterType[] {
  const quarter = dates.quarter
  const year = dates.year

  return [
    {
      type: "expected_at",
      value: `q${quarter}-${year}`,
      label: "Current Quarter"
    },
    { type: "expected_at", value: `y${year}`, label: "Current Year" },
    {
      type: "expected_at",
      value: getQuarter(year, quarter, "next"),
      label: "Next Quarter"
    },
    { type: "expected_at", value: `y${year + 1}`, label: "Next Year" },
    {
      type: "expected_at",
      value: getQuarter(year, quarter, "prev"),
      label: "Previous Quarter"
    },
    {
      type: "expected_at",
      value: `y${year - 1}`,
      label: "Previous Year"
    },
    {
      type: "all_time",
      value: "all",
      label: "All Time"
    }
  ].filter((opt) => rangeOptions.includes(opt.label))
}

export const expectedOptions = [
  { value: "current-quarter", label: "Current Quarter" },
  { value: "current-year", label: "Current Year" },
  { value: "next-quarter", label: "Next Quarter" },
  { value: "next-year", label: "Next Year" },
  { value: "previous-quarter", label: "Previous Quarter" },
  { value: "all-time", label: "All Time" },
  { value: "custom-range", label: "Custom Date Range" }
] as const

export function findExpected(expected_at: string) {
  return expectedOptions.find((exp) => exp.value === expected_at)
}

//type ExpectedType = typeof expectedOptions[number]["value"]
